<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.5 56H55V26l1.31 1a1.5 1.5 0 101.84-2.38L33.33 5.52a2.19 2.19 0 00-2.67 0L5.85 24.64A1.5 1.5 0 007.69 27L9 26v30H6.5a1.5 1.5 0 000 3h51a1.5 1.5 0 000-3zM27 56V44.5h10V56zm13 0V43.5a2 2 0 00-2-2H26a2 2 0 00-2 2V56H12V23.69L32 8.28l20 15.41V56z"/><path d="M26.5 25.5h-7A1.5 1.5 0 0018 27v7a1.5 1.5 0 001.5 1.5h7A1.5 1.5 0 0028 34v-7a1.5 1.5 0 00-1.5-1.5zm-.5 8h-6v-6h6zM44.5 25.5h-7A1.5 1.5 0 0036 27v7a1.5 1.5 0 001.5 1.5h7A1.5 1.5 0 0046 34v-7a1.5 1.5 0 00-1.5-1.5zm-.5 8h-6v-6h6z"/></svg>